<template>
  <div class="p-grid p-fluid">
    <div class="p-col-12">
      <div class="card">
        <DataTable
            dataKey="id"
            responsiveLayout="scroll"
            filterDisplay="menu"
            :lazy="true"
            :rows="15"
            :paginator="true"
            :value="referralsCodes.data"
            :totalRecords="referralsCodes.total"
            :rowHover="true"
            :loading="loading"
            @page="query.page = $event.page + 1; getReferrals()"
        >
          <template #header>
            <h2>Referrals</h2>

            <h3>Filtros</h3>

            <!-- Enabled Users Checkbox -->
            <div class="p-d-flex p-flex-row p-justify-between">
              <div class="block field-checkbox p-mt-2 p-flex-column">
                <div class="p-d-flex p-jc-between">
                  <div class="p-d-flex p-jc-end">
                    <span class="p-input-icon-left ">
                      <i class="pi pi-search"/>
                      <InputText v-model="query.search" placeholder="Nombre, email o ig..."/>
                    </span>
                  </div>
                </div>
                <div class="p-d-flex p-mt-4">
                  <div>
                    <div class="p-flex-row p-mb-2">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <Checkbox id="type" name="type" v-model="codeType" :binary="true"/>
                      <label for="type" class="p-ml-2">
                        Tipo {{ codeType ? 'Campaign' : 'User' }}
                      </label>
                    </div>
                    <div class="p-flex-row p-mb-2">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <RadioButton id="visits" name="visits" value="by_visits" v-model="filter"/>
                      <label for="visits" class="p-ml-2">
                        Ordenar por visitas
                      </label>
                    </div>
                    <div class="p-flex-row p-mb-2">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <RadioButton id="byReferrals" name="byReferrals" value="by_referrals" v-model="filter"/>
                      <label for="byReferrals" class="p-ml-2">
                        Ordenar por referido
                      </label>
                    </div>
                    <div class="p-flex-row">
                      <!--                <Checkbox id="enabledUsersFilter" v-model="query.reward_type" :binary="true"/>-->
                      <RadioButton id="nonpayment" name="nonpayment" value="by_payments" v-model="filter"/>
                      <label for="nonpayment" class="p-ml-2">
                        Ordernar por pagados
                      </label>
                    </div>
                  </div>
                  <div />
                </div>
              </div>
              <div class="">
                <Button @click="displayModal = true" class="">Crear código</Button>
              </div>
            </div>
          </template>

          <!--          <Column field="id" header="ID"></Column>-->
          <!--          <Column field="status" header="Estatus"></Column>-->
          <Column field="user.name" header="Nombre"></Column>
          <Column field="user.ig_username" header="Ig username"></Column>
          <Column field="type" header="Tipo"></Column>
          <Column header="Code">
            <template #body="{ data }">
              <div class="p-d-flex p-justify-between p-ai-center">
                <p class="p-mb-0">{{ data.code }}</p>
                <Button type="button" icon="pi pi-copy" severity="secondary" class="p-ml-2"
                        @click="doCopy(data.code)"/>
              </div>
            </template>
          </Column>
          <!--          <Column field="referred.name" header="Referido"></Column>-->
          <!--          <Column field="referred.ig_username" header="Referido IG"></Column>-->
          <Column header="Registros">
            <template #body="{ data }">
              <p>{{ data.stats?.registrations_count }}</p>
            </template>
          </Column>
          <Column header="Visitas">
            <template #body="{ data }">
              <p>{{ data.stats?.visits_count }}</p>
            </template>
          </Column>
          <Column header="Pagos">
            <template #body="{ data }">
              <p>{{ data.stats?.paying_count }}</p>
            </template>
          </Column>
          <Column field="config.subscription_trial_days" header="Sub Trial days"></Column>
          <Column field="config.subscription_coupon_percent_off" header="Sub coupon % off"></Column>
          <Column header="opciones">
            <template #body="{ data }">
              <Button type="button" icon="pi pi-cog" v-if="data.type === 'campaign'" class="p-button-rounded p-button-outlined"
                      @click="(e) => toggleMenuItems(e, data)" aria-haspopup="true" aria-controls="overlay_menu"/>
              <Menu v-if="data.type === 'campaign'" id="overlay_menu" ref="action_menu" :model="actionMenuItems" :show="displayModal" :popup="true"/>
            </template>
          </Column>
          <!--          <Column header="Fecha pago rest">-->
          <!--            <template #body="{ data }">-->
          <!--              <p v-if="data.referred.type_name === 'restaurant'">{{ formatDate(data.completed_at) }}</p>-->
          <!--              <p v-else></p>-->
          <!--            </template>-->
          <!--          </Column>-->
          <!--          <Column header="Tipo de bono">-->
          <!--            <template #body="{ data }">-->
          <!--              <div v-for="reward in data.rewards" :key="reward" class="">-->
          <!--                <span v-if="reward.amount_e2">{{ reward?.description + ": " + (reward?.amount_e2/100) + (reward?.currency === "eur" ? '€' : '$') }}</span>-->
          <!--                <span v-else>{{ reward?.description }}</span>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </Column>-->
          <!--          <Column header="Opciones">-->
          <!--            <template #body="{data}">-->
          <!--              <div v-if="getRevokeCondition(data)">-->
          <!--                <Button-->
          <!--                    type="button" icon="pi pi-cog" class="p-button-rounded p-button-outlined"-->
          <!--                    @click="toggleActionMenu($event, data)" aria-haspopup="true"-->
          <!--                    aria-controls="overlay_menu"/>-->
          <!--                <Menu ref="actionMenu" :model="actionMenuItems" :popup="true"/>-->
          <!--              </div>-->

          <!--            </template>-->
          <!--          </Column>-->

          <template #empty>
            No se encontraron rewards
          </template>
          <template #loading>
            Cargando...
          </template>
        </DataTable>
      </div>
    </div>
  </div>
  <Dialog header="Crear código de referido" v-model:visible="displayModal" :style="{width: '50vw'}"
          :modal="true">

    <div class="p-d-flex p-flex-column p-justify-content-center p-text-center">
      <div>
        <div class="p-mt-4">
          <p>Código</p>
          <InputText v-model="body.code" placeholder="Código" class=""/>
        </div>
        <div class="p-mt-4">
          <p>Descripcion</p>
          <InputText v-model="body.description" placeholder=""/>
        </div>
      </div>
      <div class="">
        <p class="p-mt-4 p-text-lg">Opcional</p>
        <div class="p-mt-4">
          <p>Subscription tial days</p>
          <InputNumber v-model="subsTrial" placeholder="Min 1"/>
        </div>
        <div class="p-mt-4">
          <p>subscription coupon percent off</p>
          <InputNumber v-model="subsCoupPercent" placeholder="100%"/>
        </div>
      </div>
    </div>
    <template #footer>
      <Button label="Cancelar" icon="pi pi-times" @click="displayModal = false" class="p-button-text"/>
      <Button label="Crear" icon="pi pi-check" @click="createCode()" :disabled="!body.description || !body.code || loadingCreate" autofocus/>
    </template>
  </Dialog>
  <Toast/>
</template>

<script>
import {useRepository} from "@/hooks";
import { onMounted, ref, watch } from "vue";
import { useToast } from 'primevue/usetoast';
import { copyText } from 'vue3-clipboard';

export default {
  setup() {
    const repository = useRepository(({ referrals }) => (referrals))
    const action_menu = ref()
    const referralsCodes = ref({})
    const $toast = useToast()
    const loading = ref(false)
    const searchDebounce = ref(null)
    const selectedCode = ref(null)
    const actionMenuItems = ref([])
    const query = ref({
      'limit': 15,
      'paginate': true,
      'page': 1,
    })
    const codeType = ref(false)
    const filter = ref('by_visits')
    const displayModal = ref(false)
    const subsTrial = ref(null)
    const subsCoupPercent = ref(null)
    const body = ref({
      description: '',
      code: '',
      // config: {
      //   subscription_trial_days: null,
      //   subscription_coupon_percent_off: null
      // }
    })
    const isEditing = ref(false)
    const loadingCreate = ref(false)
    const copied = ref(false)

    const doCopy = (invitationCode) => {
      const environment = process.env.VUE_APP_NODE_ENV === "development" ? 'https://onlyfoodies.simgulary.io' : 'https://solofoodies.com'
      const invitationRoute = 'Te han invitado a Solofoodies, tu Código es: ' + invitationCode + '\n' + environment + '/r/' + invitationCode
      copyText(invitationRoute.toString(), undefined, (error) => {
        if (error) {
          $toast.add({severity: 'error', summary: 'No se ha podido copiar el código', life: 3000});
          copied.value = false
        } else {
          $toast.add({severity: 'success', summary: 'Código copiado!', life: 2000});
          copied.value = true
        }
      })
    }

    const toggleMenuItems = (event, code) => {
      selectedCode.value = code

      actionMenuItems.value = [
        {
          label: 'Editar',
          command: () => {
            displayModal.value = true
            isEditing.value = true
            body.value = {
              description: selectedCode.value.description,
              code: selectedCode.value.code,
              config: {
                subscription_trial_days: selectedCode.value.config.subscription_trial_days,
                subscription_coupon_percent_off: selectedCode.value.config.subscription_coupon_percent_off
              }
            }
            subsTrial.value = selectedCode.value.config.subscription_trial_days
            subsCoupPercent.value = selectedCode.value.config.subscription_coupon_percent_off
            // this.$router.push({ name: 'restaurants.update', params: { restaurantId: restaurant.id } })
          }
        }
      ]

      action_menu.value.toggle(event);
    }

    const createCode = () => {
      loadingCreate.value = true

      if (subsTrial.value) {
        body.value = { ...body.value, config: { subscription_trial_days: subsTrial.value }}
      }
      if (subsCoupPercent.value) {
        body.value = { ...body.value, config: { ...body.value.config, subscription_coupon_percent_off: subsCoupPercent.value }}
      }
      if (!isEditing.value) {
        repository.create(body.value)
          .then(() => {
            displayModal.value = false
            getReferrals()
            $toast.add({severity: 'success', summary: 'se ha creado el código', life: 2000});
          })
          .catch((err) => {
            $toast.add({severity: 'error', summary: err.response.data?.message, life: 3000});
          })
          .finally(() => {
            body.value = {
              description: '',
              code: '',
              config: null,
            }
            loadingCreate.value = false
            displayModal.value = false
          })
      } else {
        repository.update(selectedCode.value.id, body.value)
          .then(() => {
            displayModal.value = false
            isEditing.value = false
            getReferrals()
            $toast.add({severity: 'success', summary: 'se ha actualizado el código', life: 2000});
          })
          .catch((err) => {
            $toast.add({severity: 'error', summary: err.response.data?.message, life: 3000});
          })
          .finally(() => {
            body.value = {
              description: '',
              code: '',
              config: null,
            }
            loadingCreate.value = false
            displayModal.value = false
            isEditing.value = false
          })
      }

    }

    const getReferrals = () => {
      loading.value = true
      const $0 = { ...query.value}

      if (query.value.search === null) {
        delete query.value.search
      }

      repository.codes($0)
          .then(({ data: resp }) => {
            referralsCodes.value = resp
          })
          .finally(() => loading.value = false)
    }

    watch(() => query.value.search, (newVal) => {
      if (newVal === null) {
        return;
      }

      if (searchDebounce.value) {
        clearTimeout(searchDebounce.value)
      }

      searchDebounce.value = setTimeout(() => {
        if (newVal === '') {
          query.value = { ...query.value, limit: 15, paginate: true, page: 1 }
        }
        getReferrals()
      }, 600)
    })

    watch(() => codeType.value, (newVal) => {
      query.value.type = newVal ? 'campaign' : 'user'
      getReferrals()
    })

    watch(() => filter.value, (newVal) => {
      console.log(newVal)
      switch (newVal) {
        case 'by_visits': {
          if (query.value.search) {
            query.value = { ...query.value, order_by_visits: 1 }
            delete query.value.order_by_referrals
            delete query.value.order_by_payments

          } else {
            query.value = {
              'limit': 15,
              'paginate': true,
              'page': 1,
              'type': query.value.type,
              'order_by_visits': 1
            }
          }

          break
        }
        case 'by_referrals': {
          if (query.value.search) {
            query.value = { ...query.value, order_by_referrals: 1 }
            delete query.value.order_by_visits
            delete query.value.order_by_payments
          } else {
            query.value = {
              'limit': 15,
              'paginate': true,
              'page': 1,
              'type': query.value.type,
              'order_by_referrals': 1
            }
          }
          break
        }
        case 'by_payments': {
          if (query.value.search) {
            query.value = { ...query.value, order_by_payments: 1 }
            delete query.value.order_by_payments
            delete query.value.order_by_referrals
          } else {
            query.value = {
              'limit': 15,
              'paginate': true,
              'page': 1,
              'type': query.value.type,
              'order_by_payments': 1
            }
          }
          break
        }
      }
      getReferrals()
    })

    onMounted(() => {
      getReferrals()
    })

    return {
      referralsCodes,
      loading,
      loadingCreate,
      query,
      filter,
      displayModal,
      body,
      subsTrial,
      subsCoupPercent,
      codeType,
      actionMenuItems,
      action_menu,
      isEditing,
      doCopy,
      toggleMenuItems,
      createCode,
      getReferrals
    };
  }
}
</script>

<style scoped>

</style>